import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';
import { AllBoatsQuery } from '../gql/graphql';

const allBoats = graphql(/* GraphQL */ `
  query allBoats {
    boats {
      boatId
      name
    }
  }
`);

const useGetBoats = () => {
  const { data, isLoading } = useQuery<AllBoatsQuery>({
    queryKey: ['boats'],
    queryFn: async () => graphqlRequest<AllBoatsQuery>(allBoats), // Public endpoint, no auth needed
    staleTime: 3600000,
    retry: shouldRetryQuery,
  });

  return {
    boats: data,
    boatLoading: isLoading,
  };
};

export default useGetBoats;
